export default __webpack_public_path__ + "static/media/slider.a8568ed0.png";